import React, { useState, useEffect } from 'react';
import '../styles/TokenExpirationModal.css';

const TokenExpirationModal = ({ 
  isOpen, 
  onClose, 
  onExtendSession, 
  timeRemaining, 
  isExpired = false 
}) => {
  const [countdown, setCountdown] = useState(timeRemaining);

  useEffect(() => {
    setCountdown(timeRemaining);
  }, [timeRemaining]);

  useEffect(() => {
    if (!isOpen || isExpired) return;

    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, isExpired]);

  if (!isOpen) return null;

  return (
    <div className="token-expiration-overlay">
      <div className="token-expiration-modal">
        <div className="modal-header">
          <div className="header-icon">
            {isExpired ? (
              <i className="bi bi-exclamation-triangle-fill expired-icon"></i>
            ) : (
              <i className="bi bi-clock-fill warning-icon"></i>
            )}
          </div>
          <h3>
            {isExpired ? 'Sesión Expirada' : 'Sesión Próxima a Expirar'}
          </h3>
        </div>

        <div className="modal-body">
          {isExpired ? (
            <div className="expired-content">
              <p>Tu sesión ha expirado por seguridad.</p>
              <p>Por favor, inicia sesión nuevamente para continuar.</p>
            </div>
          ) : (
            <div className="warning-content">
              <p>Tu sesión expirará en:</p>
              <div className="countdown-display">
                <span className="countdown-number">{countdown}</span>
                <span className="countdown-text">minutos</span>
              </div>
              <p>¿Deseas extender tu sesión?</p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          {isExpired ? (
            <button 
              className="btn btn-primary"
              onClick={onClose}
            >
              <i className="bi bi-box-arrow-in-right"></i>
              Ir al Login
            </button>
          ) : (
            <>
              <button 
                className="btn btn-secondary"
                onClick={onClose}
              >
                <i className="bi bi-x-circle"></i>
                Cerrar
              </button>
              <button 
                className="btn btn-primary"
                onClick={onExtendSession}
              >
                <i className="bi bi-arrow-clockwise"></i>
                Extender Sesión
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TokenExpirationModal;
